
import { mapActions } from 'vuex'

import loadingMixin from '@/mixins/loading'
import CurrencyMixin from '@/mixins/currency'

export default {
  mixins: [loadingMixin, CurrencyMixin],
  props: {
    productId: {
      type: Number,
      default: 0,
    },

    productName: {
      type: String,
      default: '',
    },

    priceRange: {
      type: Object,
      default() {
        return {}
      },
    },

    productItems: {
      type: Array,
      default() {
        return []
      },
    },

    productTypes: {
      type: Array,
      default() {
        return []
      },
    },

    productPhotos: {
      type: Array,
      default() {
        return []
      },
    },

    thumbnail: {
      type: String,
      default: '',
    },

    status: {
      type: String,
      default: '',
    },

    arrivalDate: {
      type: [String, Number],
      default: '',
    },
  },

  data() {
    return {
      input: {
        id: 0,
        product_id: this.$route.params.show,
        price: 0,
        quantity: 1,
        name: '',
        rest_quantity: 0,
        size: {
          length: 0,
          width: 0,
          height: 0,
          weight: 0,
        },
        thumbnail: '',
        attribute_id: 0,
      },
      modal: {
        show: false,
      },
    }
  },

  computed: {
    showSize() {
      const show =
        !this.input.size.width == (0 || '') ||
        this.input.size.height == (0 || '') ||
        this.input.size.length == (0 || '') ||
        this.input.size.weight == (0 || '')
          ? false
          : true
      return show
    },
  },
  watch: {
    productTypes: {
      handler(val) {
        if (val.length === 0) {
          this.transformInput(this.productItems)
        }

        // default selected first option
        if (val[0]?.attributes?.length > 0) {
          this.selectedAttribute(val[0]?.attributes[0])
        }
      },
      deep: false,
      immediate: true,
    },
  },

  beforeMount() {
    window.addEventListener('resize', this.onResize)
  },

  methods: {
    ...mapActions({
      setProductToCart: 'cart/setProductToCart',
    }),

    onResize() {
      if (!this.$device.isDesktop) {
        this.closeCart()
      }
    },

    showCart() {
      this.modal.show = true
      this.$nuxt.$emit('ja-backdrop', true)
    },
    closeCart() {
      this.modal.show = false
      this.$nuxt.$emit('ja-backdrop', false)
    },

    /**
     * @description: Transform Product data
     * @param {array} data
     * @return {*}
     */
    transformInput(data) {
      this.input.id = data[0].id
      this.input.name = data[0].name
      this.input.price = data[0].price
      this.input.size.height = data[0].height
      this.input.size.width = data[0].width
      this.input.size.length = data[0].length
      this.input.size.weight = data[0].weight
      this.input.rest_quantity = data[0].stock.quantity

      // thumbnail photo
      this.input.thumbnail = this.thumbnail
    },

    /**
     * @description: Selected Product Attribute
     * @param {array} attribute
     * @return {*}
     */
    selectedAttribute(attribute) {
      const product = this.productItems.filter((v) => {
        let exists = false
        v.attributes.forEach((j) => {
          exists = j.id === attribute.id
        })
        return exists
      })
      this.input.attribute_id = attribute.id
      this.transformInput(product)
    },

    /**
     * @description: Add item to cart.
     * @param {*}
     * @return {*}
     */
    addCart() {
      if (!this.input.id) {
        return this.$toast.error(this.$t('car.toast.add.faild'))
      }

      const data = {
        id: this.input.id,
        product_id: this.input.product_id,
        label: this.productName,
        type: this.input.name,
        price: parseInt(this.input.price, 10),
        quantity: this.input.quantity,
        image: this.input.thumbnail ? this.input.thumbnail : this.productPhotos[0].url,
        arrival_date: this.arrivalDate,
      }

      this.setProductToCart(data)
      this.resetCartPreview()
      this.closeCart()
      this.$toast.success(this.$t('car.toast.add.success'))
    },
    /**
     * @description: Refresh cart.
     * @param {*}
     * @return {*}
     */
    resetCartPreview() {
      this.input.quantity = 1
    },
  },
}
